<template>
  <div>
    <!--<ViewDeviceDetail ref="ViewDeviceDetail" :bg="true"></ViewDeviceDetail> -->
    <Window :bg="bg" @Closed="onClosed" ref="Window">
      <div slot="head">
        <div class="cb">
          <div :class="getTypeText(detailInfo.level,'alarmLevel')[2]" class="bgBall fL"><span>{{getTypeText(detailInfo.level,'alarmLevel')[0]}}</span></div>
          <div class="dpIB ml1x">
            <div v-if="detailInfo.showName != null" class="fs14x cField dpIB mt05x">{{detailInfo.showName}}</div><div v-else>--</div>
            <div :title="getTypeText(detailInfo.influence,'alarmInfluenceScope')[0]" :class="getTypeText(detailInfo.influence,'alarmInfluenceScope')[1]" class="mt05x">{{getTypeText(detailInfo.influence,'alarmInfluenceScope')[0]}}</div>
          </div>
        </div>
        <div class="tableSys mt1x pl1x_E">
          <div>
            <!-- v-if="'plant' == sourceType"-->
            <div class="cSub"><span>{{$t('word204',['电站'])}}</span></div>
            <div class="mt05x textCut"><span v-if="detailInfo.stationName != null" class="cMain curP" :title="detailInfo.stationName" @click="viewPlantDetail(detailInfo)" onclick="statistic('A37','A3702')">{{detailInfo.stationName}}</span><span v-else>--</span></div>
          </div>
          <div>
            <div class="cSub"><span>{{$t('device62',['设备'])}}</span></div>
            <div class="mt05x textCut">
              <span v-if="detailInfo.deviceName != null||detailInfo.deviceSn != null" class="cMain curP" :title="(detailInfo.deviceName||getTypeText(detailInfo.deviceType,'deviceType'))+ ' ' + detailInfo.deviceSn" @click="viewDetail(detailInfo)" onclick="statistic('A37','A3703')">
                {{(detailInfo.deviceName||getTypeText(detailInfo.deviceType,'deviceType'))+ ' ' + detailInfo.deviceSn}}
              </span>
              <span v-else :title="'--'">--</span>
              </div>
          </div>
          <div>
            <div class="cSub"><span>{{$t('word1482',['最后触发时间'])}}</span></div>
            <div class="mt05x textCut"><span v-if="detailInfo.alertTime !=null">{{timeFormat(detailInfo.alertTime,'utc','%Y/%m/%d %H:%M:%S UTC',{offset:timezone})}}</span><span v-else>--</span></div>
          </div>
        </div>
      </div>
      <div slot="headButton" class="dpIB fSub_E hover-f-main_E tra-fast_E">
        <button :title="$t('cmd7',['刷新'])" type="button" @click="refresh">
          <Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
      </div>
      <!-- 头部结束end -->
      <div fillHeight="lastHeight">
        <div class="navBtn pl1x bdSub-bottom-notLast">
          <div class="tabBar style-tabBar cb active-c-main_E tra-fast_E">
            <button v-for="(item,index) in btnGroup" :key="index" class="cSub afterButton" :class="{active:index==currentIndex}" @click="changeBtn(index)">{{item.title}}</button>
          </div>
        </div>
        <div fillHeight="lastHeight">
          <!-- <Detail v-show="btnGroup[currentIndex].title==$t('word706',['报警详情'])" ref="Details"></Detail> -->
          <Detail :timezone="timezone" ref="Details"></Detail>
        </div>
      </div>
      <div ref="view"></div>
    </Window>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lib from '@/util/lib'
import Window from '@/components/common/ui/WindowForView.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import ViewDeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue'
import Detail from '@/view/maintain/alarm/part/Detail'// 详情
import PlantDetail from '@/view/maintain/light/plant/ViewDetail.vue'
import WindSiteDetail from '@/view/maintain/wind/plant/ViewDetail.vue'
import { StationBasicInfo } from '@/api/maintain/plant/list.js'
import * as maintainApi from '@/api/maintain/alarm/list.js'
import * as deviceApi from '@/api/device/alarm/list.js'
import * as maintainApiList from '@/api/maintain/plant/list'
// import {dataRepeatHint, configRepeatHint} from '@/api/maintain/config/index'

export default {
  name: 'AlarmDetail',
  components: {
    Loading,
    NoResult,
    Detail,
    // ViewDeviceDetail,
    Window
  },
  props: {
    type: {// 1:电站；2:设备
      type: Number,
      default: null
    },
    bg: {// 是否显示背景遮罩
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stage,
      plantId: '',
      deviceId: '',
      ruleId: '',
      detailInfo: {},
      isEmpty: true,
      sourceType: '',
      timezone: stage.time.timeZoneCode,
      alertTime: null,
      dynamic: null// 保存动态外壳
      // offset: stage.time.offset
    }
  },
  watch: {
  },
  created () { },
  methods: {
    ...mapMutations({
      GET_CURRENTINDEX: 'alarmDetail/GET_CURRENTINDEX'
    }),
    // ...mapActions({
    // }),
    getLanguageStr,
    getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    doPermissions: lib.doPermissions,
    show: function (data, sourceType, dynamic) {
      statistic('A37', 'A3701')
      this.dynamic = dynamic
      let pass = false
      switch (this.type) {
        case 1: pass = true; break// lib.doPermissions("A/B/A11")
        // case 2:pass = lib.doPermissions('B/C/A1'); break
        default: pass = lib.doPermissions('A/D/A2'); break
      }
      if (pass) {
        this.timezone = data.timezone
        this.sourceType = sourceType
        this.plantId = data.plantId
        this.deviceId = data.deviceId
        this.ruleId = data.ruleId
        this.alertTime = data.alertTime
        this.$refs.Window.loadStatusAction(true)
        this.$refs.Window.show({ end: () => {
          this.changeBtn(this.currentIndex) // 切换tab
        } })
      } else {
        this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
      }
    },
    hide: function () {
      this.$refs.Window.hide()
    },
    myClose () {
      setTimeout(() => {
        this.GET_CURRENTINDEX(0)
      }, 500)
    },
    onClosed: function () {
      if (this.dynamic) this.dynamic.destroyUi()
    },
    viewDetail (detailInfo) {
      if (this.doPermissions('B/A/A5')) {
        // this.$emit('showDevice',detailInfo); //在上一层呈现设备详情，关闭设备详情会导致报警详情windows的z-index失去独立层叠上下文，被总导航覆盖（且以下动态组件必须在window中生成，window外生成将导致此bug）
        detailInfo.siteId = detailInfo.plantId
        this.$dynamic(this.$refs.view, ViewDeviceDetail, { bg: true, type: this.type }, {
        }, {}).then(({ instance, childInstance }) => {
          let dec = 1
          if (detailInfo.deviceType === 'COLLECTOR') {
            dec = 1
          } else {
            dec = 2
          }
          childInstance.show(detailInfo, '', instance, dec)
        })
      }
    },
    viewPlantDetail (detailInfo) {
      if (!detailInfo.stationName || detailInfo.stationName === '--') {
        return
      }
      if (this.doPermissions('A/B/A6')) {
        maintainApiList.StationBasicInfo(detailInfo.plantId).then(siteData => {
          // this.$emit('showPlant',detailInfo) //在上一层呈现电站详情，关闭电站详情会导致报警详情windows的z-index失去独立层叠上下文，被总导航覆盖（且以下动态组件必须在window中生成，window外生成将导致此bug）
          this.$dynamic(this.$refs.view, siteData.powerType === 'PV'?PlantDetail:WindSiteDetail, { bg: true }).then(({ instance, childInstance }) => {
            childInstance.show({ id: detailInfo.plantId }, instance) // instance 是否动态添加?以此决定是否销毁动态添加组件
          })
        }) 
        
      }
    },
    // 刷新详情
    refresh () {
      if (this.plantId > 0) {
        this._getDetailInfo()
        // this._getPlantTimeZone(callback)
      } else {
        this._getDetailInfo()
      }
    },
    changeBtn (index) {
      this.GET_CURRENTINDEX(index)
      if (this.currentIndex == 0) {
        if (this.plantId > 0) {
          this._getDetailInfo()
          // this._getPlantTimeZone(callback)
        } else {
          this._getDetailInfo()
        }
      }
    },
    // 获取电站时区信息
    // _getPlantTimeZone(callback){
    // 	StationBasicInfo(this.plantId).then(res=>{
    // 		if(res.region && res.region.timezone) {
    // 			this.offset = mz.tz(res.region.timezone)._offset * 60 * 1000;
    // 		}
    // 		callback()
    // 	},error=>{
    // 		callback()
    // 		!_.isEmpty(error) && this.$notify(error)
    // 	})
    // },
    // 详情信息
    _getDetailInfo () {
      if (this.sourceType == 'plant') {
        maintainApi.baseInfoGet({
          deviceId: this.deviceId,
          language: stage.languageId,
          ruleId: this.ruleId
        }).then(res => {
          this.$refs.Window.loadStatusAction(false)
          // if(res.alertTime) res.alertTime += mz.tz(this.timezone)._offset * 60;
          this.detailInfo = res
          let cloneDetailInfo = { ...this.detailInfo, ...{ alertTime: this.alertTime||this.detailInfo.alertTime, timezone: this.timezone } }
          this.$refs.Details.show(cloneDetailInfo, this.sourceType)
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      } else if (this.sourceType == 'device') {
        deviceApi.baseInfoGet({
          deviceId: this.deviceId,
          language: stage.languageId,
          ruleId: this.ruleId
        }).then(res => {
          this.$refs.Window.loadStatusAction(false)
          if (res.alertHistoryDto) {
            if (res.deviceDetailDto) {
              res.alertHistoryDto.deviceName = res.deviceDetailDto.name
              res.alertHistoryDto.deviceType = res.deviceDetailDto.type
              res.alertHistoryDto.deviceSn = res.deviceDetailDto.deviceSn
              res.alertHistoryDto.stationName = res.stationName
            }
            //          if (res.alertHistoryDto.alertTime) {
            //            res.alertHistoryDto.alertTime += mz.tz(this.timezone)._offset * 60
            //          }
          }
          this.detailInfo = res.alertHistoryDto
          this.$refs.Details.show(this.detailInfo, this.sourceType)
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      currentIndex: 'alarmDetail/currentIndex',
      btnGroup: 'alarmDetail/btnGroup'
      // userFunctions: 'user/userFunctions'
    })
  },
  mounted () {
    lib.fillHeight()
    // this.$nextTick();
    lib.setScroll($(this.$el).find('[scroll]'))
    // 点击空白处关闭窗口
    // let _this = this
    // setTimeout(() => {
    //   window.onclick = (e) => {
    //     if (e) {
    //       _this.myClose()
    //     }
    //   }
    // }, 100)
  }
}
</script>
<style lang="scss" scoped>
.bgBall {
    width: 5em;
    height: 5em;
    line-height: 5em;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/alarm/part/ViewDetail.vue